export default "__VITE_ASSET__cfe83ec7__"